import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  private _timezoneList?: string[];

  get timezoneList() {
    if (this._timezoneList) {
      return this._timezoneList;
    }

    // TODO: load all timezones.
    // this._timezoneList = [
    //   ...new Set<string>(
    //     Object.keys(tzdata.zones).filter(
    //       (tz) => tz.includes('/') && DateTime.local().setZone(tz).isValid
    //     )
    //   ),
    // ].sort((a, b) => (a < b ? -1 : 1));

    return this._timezoneList;
  }

  /**
   * e.g. PDT
   * @param dateTime
   * @returns
   */
  getLocalShortOffset(dateTime: DateTime) {
    return dateTime.toFormat('ZZZZ');
  }

  getTimezoneName(dateTime: DateTime) {
    return dateTime.zoneName;
  }
}
